/* eslint-disable import/no-cycle */

'use-strict';

import angular from 'angular';
import {
  EFileSection,
  EStaticFileType,
  File,
  StaticFile,
} from '../../src/app/@shared-types/misc/file';
import { UserRole } from '../../src/app/@types/user';
import { ApiService } from '../../src/app/shared/services/api';

export class FileAPIService {
  private apiService: ApiService;

  constructor(
    apiService: ApiService,
  ) {
    'ngInject';

    this.apiService = apiService;
  }

  public getMeta = (
    fileId: string,
  ): Promise<File> => this.apiService.get<File>(`/api/files/meta/${fileId}`);

  public getByContext = (
    section: EFileSection,
    identifier: string,
  ): Promise<File[]> => {
    const allowed = [UserRole.OFFICE, UserRole.SELLER, UserRole.SELLER_PLUS, UserRole.SERVICE];
    if (!this.apiService.isAllowed(allowed)) return Promise.resolve([]);
    return this.apiService.get<File[]>(`/api/files/${section}/${identifier}`);
  };

  public deleteFile = (
    fileId: string,
  ): Promise<void> => this.apiService.delete<void>(`/api/files/file/${fileId}`);

  public deleteStatic = (
    staticId: string,
  ): Promise<void> => this.apiService.delete<void>(`/api/files/static/${staticId}`);

  public staticsByIdentifierAndType = (
    identifier: string,
    type: EStaticFileType,
  ): Promise<StaticFile[]> => this.apiService.get<StaticFile[]>(`/api/files/static/${type}/${identifier}`);
}

export default angular.module('services.fileApiService', [])
  .service('fileApiService', FileAPIService)
  .name;
